import { render, staticRenderFns } from "./VeiculoForm.vue?vue&type=template&id=49ff6b64"
import script from "./VeiculoForm.vue?vue&type=script&lang=js"
export * from "./VeiculoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports